import { createUserSettingsSlice } from "./userSettings";

export interface AdminReportsFilters {
	districtFilter: number;
	schoolFilter: number;
	teacherFilter: number;
	courseFilter: number;
	activeSubTab: string | null;
}

const initialValues: AdminReportsFilters = {
	districtFilter: 0,
	schoolFilter: 0,
	teacherFilter: 0,
	courseFilter: 0,
	activeSubTab: null,
};

// Transient page state, kept in memory only - these filters have never survived a
// refresh, and this change does not alter that. (Switching to "session" would make
// them behave like the users list; it is a one-word change when that is wanted.)
//
// Memory-only still needs the shared model's per-user ownership: the impersonation
// handoff re-enters the SPA with navigate("/") rather than a page load, so the
// store - and these filters with it - survives the identity change intact.
export const adminReportsFilterSettings = createUserSettingsSlice<AdminReportsFilters>({
	name: "adminReportsFilter",
	initialValues,
	storage: "memory",
	// Each filter narrows the one below it, so a change invalidates what follows.
	// Declared one link at a time; the model applies the chain transitively.
	dependents: {
		districtFilter: ["schoolFilter"],
		schoolFilter: ["teacherFilter"],
		teacherFilter: ["courseFilter"],
	},
});

export const { set: setAdminReportsFilters, reset: resetAdminReportsFilters } =
	adminReportsFilterSettings;

export default adminReportsFilterSettings.reducer;
